export type TableHeaderOrientation = 'horizontal' | 'vertical';

export const DEFAULT_TABLE_HEADER_ORIENTATION: TableHeaderOrientation = 'horizontal';

export const TABLE_HEADER_HEIGHT: Record<TableHeaderOrientation, number> = {
  horizontal: 32,
  vertical: 180,
};

export const TABLE_COLUMN_GROUP_HEADER_HEIGHT = 32;
